<template>
  <div>
    <table width="100%" class="table table-striped table-hover" />
    <app-bottomModal v-if="id === 'printers'" :opened-printer="openedPrinter" />
  </div>
</template>

<script>
import 'datatables.net-editor-bs4/css/editor.bootstrap4.css'
import 'datatables.net-bs4/css/dataTables.bootstrap4.css'
import 'datatables.net-buttons-bs4/css/buttons.bootstrap4.css'
import 'datatables.net-scroller-bs4/css/scroller.bootstrap4.css'
import 'datatables.net-select-bs4/css/select.bootstrap4.css'
import 'datatables.net-colreorder-bs4/css/colReorder.bootstrap4.css'
import '@/assets/plugins/datatables/editor/title/editor.title.css'
import 'daterangepicker/daterangepicker.css'
import 'intro.js/introjs.css'
import { mapState } from 'vuex'

import BottomModal from './BottomModal.vue'
const JSZip = require('jszip')
window.JSZip = JSZip
const intlTelInput = require('intl-tel-input')
window.intlTelInput = intlTelInput
require('datatables.net/js/jquery.dataTables.js')
require('datatables.net-editor/js/dataTables.editor.js')
require('datatables.net-editor-bs4/js/editor.bootstrap4.js')
require('datatables.net-bs4/js/dataTables.bootstrap4.js')
require('datatables.net-buttons/js/dataTables.buttons.js')
require('datatables.net-scroller/js/dataTables.scroller.js')
require('datatables.net-select/js/dataTables.select.js')
require('datatables.net-buttons/js/buttons.colVis.js')
require('datatables.net-buttons/js/buttons.html5.js')
require('datatables.net-buttons/js/buttons.print.js')
require('datatables.net-buttons-bs4/js/buttons.bootstrap4.js')
require('datatables.net-colreorder/js/dataTables.colReorder.js')
require('datatables.net-colreorder/js/dataTables.colReorder.js')
require('@/script/datatables.extend.js')
require('@/assets/plugins/datatables/editor/title/editor.title.js')
require('@/assets/plugins/datatables/editor/number/editor.number.js')
require('@/assets/plugins/datatables/editor/telephone/editor.telephone.js')
require('@/assets/plugins/datatables/editor/fields/yesno.js')
require('@/assets/plugins/datatables/datetime-moment.js')
require('@/assets/plugins/datatables/processing().js')
require('@/assets/plugins/datatables/absolute-sorting.js')

const daterangepicker = require('daterangepicker')

const introJs = require('intro.js')

Date.daysBetween = (date1, date2) => {
  const one_day = 1000 * 60 * 60 * 24
  const date1_ms = date1.getTime()
  const date2_ms = date2.getTime()
  const difference_ms = date2_ms - date1_ms
  return Math.round(difference_ms / one_day)
}

const defaultOpenedPrinter = { parsed: { counters: {} } }

window.endDate = moment()

export default {
  data () {
    return {
      id: '',
      table: null,
      columns: [],
      uniqueColumns: [],
      data: [],
      computers: [],
      openedPrinter: defaultOpenedPrinter,
      intro: null,
      introSteps: [],
      markerSupplies: [],
      mediaInputs: [],
      startDate: moment().subtract(1, 'months'),
      endDate: window.endDate,
      ranges: {
        Today: [moment(), moment()],
        'Last Day': [moment().subtract(1, 'days'), moment()],
        'Last Week': [moment().subtract(1, 'weeks'), moment()],
        'Last Month': [moment().subtract(1, 'months'), moment()],
        'Last Year': [moment().subtract(1, 'years'), moment()]
      },
      OLD: moment()
        .subtract(3, 'days')
        .startOf('day')
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.data,
      ref: state => state.user.ref,
      firebase: state => state.firebase,
      clients: state => state.user.clients,
      clientSelected: state => state.user.clientSelected,
      clientUser: state => state.user.clientUser,
      groups: state => state.user.groups,
      policies: state => state.user.policies,
      columnsConnected: state => state.columnsConnected,
      desktop: state => state.user.desktop,
      app: state => state.user.app,
      service: state => state.user.service
    })
  },
  watch: {
    clients: async function (ref) {
      const _this = this
      if (_this.$root.$children[0].$refs.topheader.isRefreshed) return
      if (_this.clientUser && !_this.clientSelected) {
        _this.$store.dispatch('user/clientSelected', 'all')
      }
      _this.clearData(_this)
      switch (_this.id) {
        case 'computers': {
          console.log('usersTable')
          _this.usersTable(this)
          break
        }
        case 'printers': {
          _this.printersTable(this)
          break
        }
        case 'usage': {
          _this.usageTable(this)
          break
        }
        case 'services': {
          _this.managedTable(this)
          break
        }
        // case 'clients': {
        //   _this.clientsTable(this)
        //   break
        // }
        // case 'groups': {
        //   _this.groupsTable(this)
        //   break
        // }
        // case 'policies': {
        //   _this.policiesTable(this)
        // }
      }

      setTimeout(() => $(window).resize(), 0)
    },
    clientSelected: async function (ref) {
      const _this = this
      _this.clearData(_this)
      switch (_this.id) {
        case 'printers': {
          _this.printersTable(this)
          break
        }
      }

      setTimeout(() => $(window).resize(), 0)
    }
  },
  mounted () {
    let _this = this
    const $el = $(_this.$el)
    const $section = $el.closest('.section')
    _this.id = $section.attr('data-id')
    _this.intro = introJs()
    // $el.on("click", ".buttons-collection", e => {
    //   setTimeout(() => {
    //     if (
    //       $(e.target)
    //         .closest("button")
    //         .hasClass("buttons-colvis")
    //     ) {
    //       const $firstItm = $(".dt-button-collection .dropdown-item:first");
    //       if ($firstItm.text() == "") $firstItm.remove();
    //     }
    //     if (!$(".dt-button-collection").length)
    //       setTimeout(() => $el.click(), 10);
    //   }, 0);
    // });
    $el.on('click', 'tbody tr > td:not(:nth-child(1))', function () {
      const row = _this.table.row($(this).parent())
      switch (_this.id) {
        case 'printers':
          const $printerModal = $('#printer-modal')
          _this.openedPrinter = defaultOpenedPrinter
          _this.openedPrinter = row.data()
          if (_this.openedPrinter.active) {
            $printerModal.modal('show')
          }
          break
      }
    })

    if (!$.fn.dataTable.ext.editorFields) $.fn.dataTable.ext.editorFields = {}
    $.fn.dataTable.moment(_this.t('momentformat'))
  },
  components: {
    'app-bottomModal': BottomModal
  }
}
</script>
<style lang="scss">
button.inputButton {
  float: left;
  text-align: center;
  display: block;
  cursor: pointer;
  margin: 0 20px 10px 0;
  padding: 6px 0;
  background: #f8f8f8;
  background: -webkit-gradient(
    linear,
    center bottom,
    center top,
    from(#ccc),
    to(white)
  );
  background: -moz-linear-gradient(top, white, #ccc);
  background: linear-gradient(to bottom, white, #ccc);
  text-shadow: 0 1px 0 white;
  border: 1px solid #999;
  border-radius: 3px;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  box-shadow: 0px 0px 2px #999;
  -moz-box-shadow: 0px 0px 2px #999;
  -webkit-box-shadow: 0px 0px 2px #999;
  width: 80px;
}
button.inputButton.selected {
  font-weight: normal;
  background: #02475a;
  background: -webkit-gradient(
    linear,
    center bottom,
    center top,
    from(#777),
    to(#333)
  );
  background: -moz-linear-gradient(top, #333, #777);
  background: linear-gradient(to bottom, #333, #777);
  box-shadow: inset 0px 0px 2px #222;
  -moz-box-shadow: inset 0px 0px 2px #222;
  -webkit-box-shadow: inset 0px 0px 2px #222;
  color: white;
  text-shadow: none;
}

#qrcode-modal {
  .modal-footer {
    padding: 20px 24px;
  }
}

#app {
  .dt-buttons {
    &.dt-header-buttons {
      margin-top: 7px;
      &.right {
        float: right;
        padding-right: 5px;
      }
      button.btn {
        border: 0;
        &.btn-secondary {
          &.disabled {
            color: unset;
            background-color: unset;
            opacity: 0.25;
          }
        }
        span.icon {
          &::before {
            font-size: 20px;
          }
        }
      }
    }
    span {
      text-transform: capitalize;
      line-height: 27px;
      padding-right: 5px;
    }
  }
  table.dataTable {
    thead {
      th {
        text-transform: capitalize;
      }
    }
    tbody {
      tr {
        cursor: pointer;
        &.old {
          color: #9e9e9e;
        }
        td {
          &.select-checkbox {
            padding: 0px;
            height: 45px;
            display: flex;
            justify-content: center;
            &::before,
            &::after {
              top: 1.7em;
              left: unset;
            }
          }
          &.button {
            padding: 0;
          }
          &.status {
            text-transform: capitalize;
            span {
              &.warning {
                color: #d4a600;
              }
              &.critical {
                color: orangered;
              }
            }
          }
          .btn {
            &.downloadLink {
              &.btn-secondary {
                &:hover {
                  color: #ffffff;
                  border-color: #000000;
                  background-color: #949494;
                }
                &:not([disabled]) {
                  &:not(.disabled):active {
                    color: #ffffff;
                    border-color: #000000;
                    background-color: #099bc3;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .mai-datatable-footer {
    .switch-button {
      line-height: 16px;
      width: 50px;
      height: 20px;
      border-radius: 10px;
      label {
        height: 16px;
        width: 16px;
        border-radius: 10px;
        &:before {
          line-height: 20px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Datatable.vue